import { Link, type LinkProps } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

export const InternalLink = (props: LinkProps) => {
  const { classes } = useStyles();

  return (
    <Link className={classes.link} {...props}>
      {props.children}
    </Link>
  );
};
